import styled from 'styled-components';

const FileDownload = styled.button`
  &&& {
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    font-size: 0.875rem;
    margin-left: 0.5rem;

    &:focus {
      outline: 0;
    }

    &:hover {
      border-bottom: 1px solid #999a9a;
      background: transparent !important;
      cursor: pointer;

      & + svg {
        opacity: 1;
      }
    }
  }
`;

export default FileDownload;
